module.exports = __webpack_public_path__ + "eb2eb363236a34f3ddef25193e87c769.jpg";